import * as React from 'react';
import { Link } from 'react-router-dom';

const PageNotFound = () => {
  return (
    <div className="text-center">
      <h1>{'404'}</h1>
      <h3>{'Sorry, this page doesn’t exist.'}</h3>
      <h4><Link to={'/'} style={{ color: '#0a2b5f' }} >Back to home page</Link></h4>
    </div>
  );
};
export default PageNotFound;



// WEBPACK FOOTER //
// ./src/app/scenes/Content/scenes/PageNotFound/index.jsx